export default __webpack_public_path__ + "graphics/smartphone.e82f8819.png";